import { IFSPrinterClient } from "./IFSPrinterClient";

export class FakeFSPrinterClient implements IFSPrinterClient {
    public async printRSV(): Promise<void> {
        return Promise.resolve();
    }

    public async print(): Promise<void> {
        return Promise.resolve();
    }

    public printByRules(): Promise<void> {
        return Promise.resolve();
    }
}
